var _rect, _path, _path2, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOfflineSiteMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#999898"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9987 18.3359V24.3359H30.332L23.6654 31.6693V25.6693H20.332L26.9987 18.3359Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2483 17.7119C27.5012 17.8132 27.667 18.0583 27.667 18.3308V23.6641H29.888C30.7677 23.6641 31.2188 24.7182 30.6114 25.3546L24.1492 32.1244C23.9611 32.3215 23.672 32.3843 23.4191 32.2829C23.1661 32.1816 23.0003 31.9365 23.0003 31.6641V26.3308H20.7793C19.8996 26.3308 19.4485 25.2766 20.056 24.6403L26.5181 17.8704C26.7062 17.6733 26.9954 17.6106 27.2483 17.7119ZM21.5583 24.9974H23.667C24.0352 24.9974 24.3337 25.2959 24.3337 25.6641V30.0002L29.109 24.9974H27.0003C26.6321 24.9974 26.3337 24.6989 26.3337 24.3308V19.9947L21.5583 24.9974Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 45,
    height: 45,
    rx: 22.5,
    stroke: "#999898",
    strokeOpacity: 0.2,
    strokeWidth: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineSiteMarker);
export default __webpack_public_path__ + "static/media/offlineSiteMarker.ea8ab944d2d59ce7b01cb19bf959f418.svg";
export { ForwardRef as ReactComponent };